import {
  fetchDELETE,
  fetchGET,
  fetchPOST,
  fetchPUT,
} from "../utils/handler_http";
import { encoURI, encoUriJson } from "../utils/handler_validations";

const getUpdateDynamicRateTemplate = () => ({
  id: "",
  isActivate: false,
  name: "",
  ubicationName: "",
  ubicationCoordinates: {},
  initialRate: 0,
  isDynamic: false,
  pricePerKilometer: 0,
  kilometers: 0,
  startHour: "",
  endHour: "",
  priceOnDemand: 0,
  isDemand: false,
  startHour2: "",
  endHour2: "",
  priceOnDemand2: 0,
  isDemand2: false,
  color: "orange",
  priority: "ninguno",
  polygons: [],
});

/**
 * Lista de tarifas dinámicas
 */

export const getListDynamicRates = async (
  filterValue = "",
  filterStatus = {},
  jwt = "",
) => {
  const paramsQuery = {
    filterValue: encoURI(filterValue),
    filterStatus: encoUriJson(filterStatus),
  };
  const response = await fetchGET(
    process.env.REACT_APP_DYNAMIC_RATE_LIST_ENDPOINT,
    paramsQuery,
    { Authorization: jwt },
  );
  return response;
};

export const updateDynamicRate = async (
  data = getUpdateDynamicRateTemplate(),
  jwt = "",
) => {
  const paramsBody = {
    id: encoURI(data.id),
    isActivate: data.isActivate,
    name: encoURI(data.name),
    ubicationName: encoURI(data.ubicationName),
    ubicationCoordinates: encoUriJson(data.ubicationCoordinates),
    initialRate: encoURI(data.initialRate),
    isDynamic: data.isDynamic,
    pricePerKilometer: encoURI(data.pricePerKilometer),
    kilometers: encoURI(data.kilometers),
    startHour: encoURI(data.startHour),
    endHour: encoURI(data.endHour),
    priceOnDemand: encoURI(data.priceOnDemand),
    isDemand: data.isDemand,
    startHour2: encoURI(data.startHour2),
    endHour2: encoURI(data.endHour2),
    priceOnDemand2: encoURI(data.priceOnDemand2),
    isDemand2: data.isDemand2,
    color: encoURI(data.color) || "orange",
    priority: encoURI(data.priority) || "ninguno",
    polygons: encoUriJson(data.polygons),
  };

  const response = await fetchPUT(
    process.env.REACT_APP_DYNAMIC_RATE_ENDPOINT,
    paramsBody,
    { Authorization: jwt },
  );
  return response;
};

export const createDynamicRate = async (
  data = getUpdateDynamicRateTemplate(),
  jwt = "",
) => {
  const paramsBody = {
    id: encoURI(data.id),
    isActivate: data.isActivate,
    name: encoURI(data.name),
    ubicationName: encoURI(data.ubicationName),
    ubicationCoordinates: encoUriJson(data.ubicationCoordinates),
    initialRate: encoURI(data.initialRate),
    isDynamic: data.isDynamic,
    pricePerKilometer: encoURI(data.pricePerKilometer),
    kilometers: encoURI(data.kilometers),
    startHour: encoURI(data.startHour),
    endHour: encoURI(data.endHour),
    priceOnDemand: encoURI(data.priceOnDemand),
    isDemand: data.isDemand,
    startHour2: encoURI(data.startHour2),
    endHour2: encoURI(data.endHour2),
    priceOnDemand2: encoURI(data.priceOnDemand2),
    isDemand2: data.isDemand2,
    color: encoURI(data.color),
    priority: encoURI(data.priority),
    polygons: encoUriJson(data.polygons),
  };
  const response = await fetchPOST(
    process.env.REACT_APP_DYNAMIC_RATE_ENDPOINT,
    paramsBody,
    { Authorization: jwt },
  );
  return response;
};

export const deleteRate = async (ids = [], jwt = "") => {
  const paramsBody = {
    rateIds: encoUriJson(ids),
  };
  const response = await fetchDELETE(
    process.env.REACT_APP_DYNAMIC_RATE_ENDPOINT,
    paramsBody,
    { Authorization: jwt },
  );
  return response;
};

export const getLocalityPaths = async (name = "", jwt = "") => {
  const nameLocality = name;
  const response = await fetch(
    `https://nominatim.openstreetmap.org/search?q=${nameLocality}&format=json&polygon_geojson=1&featureType=boundary`,
    {
      method: "GET",
    },
  );
  const data = await response.json();
  return data;
};
